import type { Form } from 'factorial-form'
import each from 'lodash/each'
import findIndex from 'lodash/findIndex'
import type { IObservableArray } from 'mobx'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'
import BaseFormCollection from 'modules/reports/lib/Store/FormCollections/Base'
import type Field from 'modules/reports/store/models/Field'
import type { ProjectionParams } from 'modules/reports/store/models/Projection'

import ProjectionForm from './ProjectionForm'

interface Props {
  projections: ProjectionParams[]
}

class ProjectionFormCollection extends BaseFormCollection<ProjectionForm> {
  constructor(props: Props) {
    super()

    const { projections } = props
    this.FormClass = ProjectionForm
    this.forms = projections.map((p) => new ProjectionForm(p)) as IObservableArray<ProjectionForm>
  }

  convertToParams(): ProjectionParams[] {
    return this.forms.map((f: ProjectionForm) => f.data()) as ProjectionParams[]
  }

  reorderFields(fields: FieldType[]) {
    this.forms?.replace(fields.map((item) => item.form))
  }

  paths(): string[] {
    return this.forms.map((p) => p.serialized).map((p) => p.path)
  }

  addFieldsWithGroup(fields: Field[], uiGroup?: string) {
    if (!uiGroup) return this.addFields(fields)

    each(fields, (field: Field) => {
      const fieldIndex = findIndex(
        this.forms,
        (form: Form) =>
          form.values.path.value === field.attributes.path && form.values.ui_group === uiGroup
      )

      const index = fieldIndex >= 0 ? fieldIndex : this.forms.length
      this.updateOrCreate(index, {
        path: field.attributes.path,
        ui_group: uiGroup,
      })
    })
  }
}

export default ProjectionFormCollection
